module.exports = "/_next/static/images/8ae2609a7986e62763d154140586c505-shield-icon.svg.webp";